var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',{attrs:{"d-flex":"","align-center":""}},[_c('v-icon',{attrs:{"size":"5","color":_vm.statusCircleIndicatorColor}},[_vm._v(" mdi-circle ")]),_c('span',{class:'font-weight-medium ml-2 text-caption ' + _vm.statusChipTextColor},[_vm._v(" "+_vm._s(_vm.statusDisplayText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }